import { Component, Input, OnChanges, SimpleChanges, ViewChild } from '@angular/core';
import { faFileExcel, faFileImage, faFilePdf, faFileWord, faTrashAlt } from '@fortawesome/free-solid-svg-icons';
import { TranslateService } from '@ngx-translate/core';
import { ConfirmModalComponent } from 'src/app/shared/confirm-modal/confirm-modal.component';
import { ToastService } from 'src/app/shared/toast/toast.service';
import { VssFile, VssFilesUploadService } from './vss-files-upload.service';

@Component({
    selector: 'app-vss-files-upload',
    templateUrl: './vss-files-upload.component.html',
    styleUrls: ['./vss-files-upload.component.css'],
    standalone: false
})
export class VssFilesUploadComponent implements OnChanges {

  @ViewChild('confirmModal') confirmModal: ConfirmModalComponent;

  @Input() type: string;
  @Input() organizationId: number;

  public loading = true;
  public icons: { [name: string]: any } = {
    'faFileWord': faFileWord,
    'faFilePdf': faFilePdf,
    'faFileImage': faFileImage,
    'faFileExcel': faFileExcel,
    'faTrashAlt': faTrashAlt
  };
  public files: VssFile[] = [];
  public fileSizeError = false;
  public missingFileError = false;
  public regExError = false;

  private _imageToUpload: File = null;

  constructor(private _vssFilesUploadService: VssFilesUploadService, private _translate: TranslateService,
    private _toastService: ToastService) { }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.organizationId.currentValue) {
      this._vssFilesUploadService.getVssOrganizationFiles(changes.organizationId.currentValue, this.type).subscribe(result => {
        this.files = result;
        this.loading = false;
      });
    }
  }

  deleteVssFile(fileId: number) {
    this.confirmModal.open(this._translate.instant('VSS.FILES.deleteFile'), this._translate.instant('VSS.FILES.deleteFileQuestion'));
    this.confirmModal.confirmationResult.subscribe(result => {
      if (result) {
        this.loading = true;
        this._vssFilesUploadService.deleteFile(fileId, this.type).subscribe(deleteResult => {
          const elm = this.files.filter(f => f.id === fileId)[0];
          const index = this.files.indexOf(elm);
          this.files.splice(index, 1);
          this.loading = false;
        });
      }
    });
  }
  // ^.*\.(jpg|JPG|gif|GIF|doc|DOC|pdf|PDF)$
  handleImageFileInput(event: any) {
    const files = event.target.files;
    this.fileSizeError = false;
    this.missingFileError = false;
    this.regExError = false;
    if (files.length === 0) { return; }
    if (files.length > 1) { return; }
    const mimeType = files[0].name;
    if (mimeType.match(/^.+\.(?:(?:[dD][oO][cC][xX]?)|(?:[pP][dD][fF])|(?:[jJ][pP][gG])|(?:[jJ][pP][eE][gG])|(?:[pP][nN][gG]))$/) == null) {
      console.log('ERROR');
      this.regExError = true;
      return;
    }
    if (files[0].size > 9500000) {
      this.fileSizeError = true;
      return;
    }
    const reader = new FileReader();
    this._imageToUpload = files.item(0);
    reader.readAsDataURL(files[0]);
  }

  uploadFile() {
    if (this.regExError) {
      return;
    }
    if (this._imageToUpload) {
      this.loading = true;
      const imageFileNameArray = this._imageToUpload.name.split('.');
      this._vssFilesUploadService.uploadFile(this._imageToUpload, imageFileNameArray[0], this.organizationId, this.type)
        .subscribe(result => {
          this.files.push(result);
          this._imageToUpload = null;
          this.loading = false;
        });
    } else {
      this.missingFileError = true;
    }
  }

}
